import { Epic } from 'redux-observable';
import { Observable } from 'rxjs';

import { Action } from '../actions';
import { requestClientMobileAppsData } from '../actions/clientMobileAppsData';
import { showCommonDataFetchError } from '../actions/common';
import { FETCH_APPS_DATA, FetchAppsData, updateAppsData } from '../actions/mobile-apps-list';
import { ApiMethodExecutingError } from '../service/Errors';
import '../service/Rx';
import { EpicDeps } from '../service/StoreFactory';
import { State } from '../typings/state';

const fetchMobileAppsListEpic: Epic<Action, Action, State, EpicDeps> = (action$, store$, deps) => {
    return action$.ofType(FETCH_APPS_DATA).mergeMap((action: FetchAppsData) => {
        return Observable.of(requestClientMobileAppsData()).concat(
            Observable.fromPromise(deps.restApiManager.getAppsData(action.login))
                .map(updateAppsData)
                .catch((err: ApiMethodExecutingError) => {
                    return Observable.of(showCommonDataFetchError(err));
                })
        );
    });
};

export { fetchMobileAppsListEpic };
